import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { handleApiCall } from "../../../apis";
import { endpoints } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import DOMPurify from "dompurify";
import he from "he";
import viewImage from "../../../assets/images/icons/view.svg";
import DateRangeSelectButton from "../../../commons/DateRangeSelectButton/DateRangeSelectButton";
import TablePagination from "../../../commons/Pagination/TablePagination";

const Restaurant = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  // const getCms = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await handleApiCall("get", `${endpoints.getCMSoverview}`);
  //     if (response?.data?.code === 200) {
  //       const item = response?.data?.data?.description;
  //       const decoded = he.decode(item || ""); // decode HTML entities
  //       const sanitized = DOMPurify.sanitize(decoded); // sanitize the HTML
  //       setData(sanitized);
  //     } else {
  //       toast.error(response?.data?.message || "Technical Issue. Try Again...");
  //     }
  //   } catch (error) {
  //     setError(true);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleDateApply = () => {
    // Hook up payout date filter API when available
  };

  return (
    <>
      <div className="text-end px-0 mb-3">
        <DateRangeSelectButton onApply={handleDateApply} />
      </div>
      <div className="table-responsive px-0">
        <table className="table table-striped">
          <thead>
            <tr>
              <th width="200">Transaction ID</th>
              <th width="150">Transaction Date</th>
              <th>Transaction Status</th>
              <th>Amount</th>
              <th>Method</th>
              <th>Scheduled Date</th>
              <th className="text-center">Action</th>
            </tr>
          </thead>
          <tbody>                      
              <tr>
                  <td className="text-left">#2313343</td>
                  <td>24-April-2025</td>
                  <td>Paid</td>
                  <td>£10.2</td>
                  <td>Stripe</td>
                  <td>26-May-2025</td>
                  <td>
                      <div className="d-flex align-items-center justify-content-center">
                          <Link to='/payout-management/driver' className="mx-2">
                              <img src={viewImage} alt="View" />
                          </Link>
                      </div>
                  </td>
              </tr>
              <tr>
                  <td className="text-left">#2313343</td>
                  <td>24-April-2025</td>
                  <td>Paid</td>
                  <td>£10.2</td>
                  <td>Stripe</td>
                  <td>26-May-2025</td>
                  <td>
                      <div className="d-flex align-items-center justify-content-center">
                          <Link to='/payout-management/driver' className="mx-2">
                              <img src={viewImage} alt="View" />
                          </Link>
                      </div>
                  </td>
              </tr>
              <tr>
                  <td className="text-left">#2313343</td>
                  <td>24-April-2025</td>
                  <td>Paid</td>
                  <td>£10.2</td>
                  <td>Stripe</td>
                  <td>26-May-2025</td>
                  <td>
                      <div className="d-flex align-items-center justify-content-center">
                          <Link to='/payout-management/driver' className="mx-2">
                              <img src={viewImage} alt="View" />
                          </Link>
                      </div>
                  </td>
              </tr>
              <tr>
                  <td className="text-left">#2313343</td>
                  <td>24-April-2025</td>
                  <td>Paid</td>
                  <td>£10.2</td>
                  <td>Stripe</td>
                  <td>26-May-2025</td>
                  <td>
                      <div className="d-flex align-items-center justify-content-center">
                          <Link to='/payout-management/driver' className="mx-2">
                              <img src={viewImage} alt="View" />
                          </Link>
                      </div>
                  </td>
              </tr>
              <tr>
                  <td className="text-left">#2313343</td>
                  <td>24-April-2025</td>
                  <td>Paid</td>
                  <td>£10.2</td>
                  <td>Stripe</td>
                  <td>26-May-2025</td>
                  <td>
                      <div className="d-flex align-items-center justify-content-center">
                          <Link to='/payout-management/driver' className="mx-2">
                              <img src={viewImage} alt="View" />
                          </Link>
                      </div>
                  </td>
              </tr>
              {/* <tr>
                <td colSpan="6" className="text-center py-4">
                  No Data Found
                </td>
              </tr> */}
          </tbody>
        </table>
      </div>
              <TablePagination page={page} totalPages={totalPages} onPageChange={setPage} />

    </>
  );
};

export default Restaurant;
